import { privacyPolicy } from "./privacy-policy";
import { refundPolicy } from "./refund-policy";
import { termsOfService } from "./terms-of-service";

export const POLICY_DOCUMENTS = [
  {
    slug: "terms-of-service",
    content: termsOfService,
    label: "Terms of service",
  },
  { slug: "privacy-policy", content: privacyPolicy, label: "Privacy policy" },
  { slug: "refund-policy", content: refundPolicy, label: "Refund policy" },
] as const;
